import { Checkbox } from '@lendi-ui/checkbox';

import { FIELD_PATHS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { ApplicantEntityIndex } from '@funnels/types';

import { CheckboxWrapper } from './index.style';

interface CompanyRegisteredForGstProp extends ApplicantEntityIndex {
  isNotRegisteredForGST: boolean;
}

export const CompanyRegisteredForGst = ({ applicantIndex, isNotRegisteredForGST }: CompanyRegisteredForGstProp) => {
  const [_, setFormValues] = useFormValues();

  const handleGSTUpdate = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setFormValues(FIELD_PATHS.APPLICANT_COMPANY_NOT_REGISTERED__FOR_GST(applicantIndex), checked);
  };

  return (
    <CheckboxWrapper>
      <Checkbox
        label={'Not registered for GST'}
        isChecked={isNotRegisteredForGST}
        onChange={handleGSTUpdate}
        data-component="not-registered-for-gst-company-checkbox"
      />
    </CheckboxWrapper>
  );
};
